import { useMeta } from '@nuxtjs/composition-api'

export default function () {
  useMeta(() => ({
    meta: [
      { hid: 'robots', name: 'robots', content: 'noindex,nofollow' },
    ],
  }))
}
